{
	"de": "lang/de.80b1dadca64841a42a311d6282bdc5dd8f574a4d.json",
	"en_GB": "lang/en_GB.4f3339da1b7f61db0160b4101190518e45db118a.json",
	"en": "lang/en.680465ce4d52ba91bce1e9c9169958ed17cceb5c.json",
	"es_ES": "lang/es_ES.4f480a29389a2527c511fa24fe6ec53f2bc6f357.json",
	"es_LA": "lang/es_LA.4bfcea8a532264524d8d096e903e3fe4b8bdba48.json",
	"fr": "lang/fr.2cac130d8c41bbcba18f4840e309ec4a84b86d77.json",
	"it": "lang/it.50036e36a264cea28ff04bb357e5c3be456613f9.json",
	"ja": "lang/ja.efd8b1b50a0164c24a72e4a15a16942ebc93209a.json",
	"ko": "lang/ko.85c372ce971735af602887273408a7d74459a325.json",
	"nl": "lang/nl.b5ad882b2e405e273c34e5f3e8bd1dd4b8b4bd8c.json",
	"no": "lang/no.ca2e4f62d1b226c117d4a1d991d3508041c501fb.json",
	"pt_BR": "lang/pt_BR.ac82d1d9d1aab953022152b5699b9d53cdc3c776.json",
	"sv": "lang/sv.a777c052f27e33fcbe38cab617de503375039d83.json",
	"th": "lang/th.4203096a34e56b5cb02593fb83373ffff1acaf5b.json",
	"zh_TW": "lang/zh_TW.de588f7b4b4e02452aa69cd21a9f1ee0604bf86d.json",
	"zh": "lang/zh.0a4c15c0b60173133a3d88210bec736bce29ebf9.json"
}
